<template>
  <div>
    <b-overlay :show="loading" rounded="sm" opacity="0.75">
      <b-row class="my-1">
        <b-col>
          <b-row class="mt-1">
            <b-col>
              <span style="font-size: 30px; font-weight: bold" v-if="hasDetails">
                {{detailsForm.name || detailsForm.companyName}}
              </span>
            </b-col>
          </b-row>
          <b-row class="mt-1" v-if="hasDetails">
            <b-col cols="12">
              <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                <thead>
                <tr class="bg-gray-pale">
                  <td colspan="12" class="px-2 py-2">Application Details</td>
                </tr>
                <tr>
                  <th class="px-2 py-1">Tracking Number</th>
                  <th class="px-2 py-1">Status</th>
                  <th class="px-2 py-1">Years Filing</th>
                  <th class="px-2 py-1">Submission Date</th>
                </tr>
                </thead>
                <tbody>
                <tr style="border: solid 1px #dedede;" >
                  <td class="px-2 py-1">
                    <span class="text-gray">
                      {{effectiveTrackingNumber}}
                    </span>
                  </td>
                  <td class="px-2 py-1">
                    <span class="text-gray text-capitalize">{{detailsStatus}}</span>
                  </td>
                  <td class="px-2 py-1">
                    <div class="years-wrap">
                      <b-badge
                        v-for="(year, idx) in yearsFiling"
                        :key="`${year}-${idx}`"
                        class="year-chip"
                      >
                        {{ year }}
                      </b-badge>
                      <span v-if="yearsFiling.length === 0" class="text-gray">-</span>
                    </div>
                  </td>
                  <td class="px-2 py-1">
                    <span class="text-gray italic">
                      {{dateTimeFormat(detailsForm.createdAt)}}
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="hasDetails">
            <b-col cols="12">
              <div v-if="hasPaymentDetails">
                <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2">Payment Details</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 font-bold">PRN</td>
                    <td class="px-2 py-1">{{ paymentPrn || "-" }}</td>
                  </tr>
                  <tr v-if="paymentStatus" style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 font-bold">Status</td>
                    <td class="px-2 py-1 text-capitalize">{{ String(paymentStatus).toLowerCase().replaceAll("_", " ") }}</td>
                  </tr>
                  </tbody>
                </table>
                <div class="mt-2" v-if="paymentPrn">
                  <PRNViewer :tracking-number="effectiveTrackingNumber" :prn="paymentPrn"/>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="my-2" v-if="hasDetails">
            <b-col>
              <b-row>
                <b-col>
                  <div class="flex h-full" style="cursor: pointer;">
                    <div :class="[(currentRoute === 'forms') ? 'menu-item-active' : 'menu-item']" @click="select('forms')">
                      <div class="flex mt-6">
                        <div style="font-size: 14px">Filing Information</div>
                      </div>
                    </div>
                    <div :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']" @click="select('attachments')">
                      <div class="flex mt-6">
                        <div style="font-size: 14px">Attachments</div>
                      </div>
                    </div>
                    <div :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']" @click="select('messages')">
                      <div class="flex mt-6">
                        <div style="font-size: 14px">Messages</div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <BusinessAnnualReturnForms
                    :key="`forms-${effectiveTrackingNumber || 'none'}`"
                    :task="detailsForm"
                    :tracking-number="effectiveTrackingNumber"
                    v-if="currentRoute === 'forms'"
                  />
                  <BusinessAnnualReturnFormFiles
                    :task="detailsForm"
                    :tracking-number="effectiveTrackingNumber"
                    v-if="currentRoute === 'attachments'"
                  />
                  <BusinessAnnualReturnMessages
                    :tracking-number="effectiveTrackingNumber"
                    v-if="currentRoute === 'messages'"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PRNViewer from "@/views/home/commons/PRNViewer.vue";
import BusinessAnnualReturnForms
    from "@/views/home/services/business-annual-returns/task/BusinessAnnualReturnForms.vue";
import BusinessAnnualReturnFormFiles
    from "@/views/home/services/business-annual-returns/task/BusinessAnnualReturnFormFiles.vue";
import BusinessAnnualReturnMessages
    from "@/views/home/services/business-annual-returns/task/BusinessAnnualReturnMessages.vue";


export default {
  name: "BusinessAnnualReturnsDetails",
  components: {BusinessAnnualReturnMessages, BusinessAnnualReturnFormFiles, BusinessAnnualReturnForms,  PRNViewer},
  props:{trackingNumber:String},
  data(){
    return{
      currentRoute: "forms",
      loading:false,
    }
  },
  mounted() {
    this.loadDetails()
  },
  methods:{
    ...mapActions(["fetchBusinessAnnualReturnsDetails"]),
    loadDetails(){
      if(!this.trackingNumber){
        this.loading = false
        return
      }
      this.loading = true
      this.fetchBusinessAnnualReturnsDetails(this.trackingNumber)
    },
    select(route){
      this.currentRoute = route
      if((route === "forms" || route === "attachments") && this.effectiveTrackingNumber){
        this.loading = true
        this.fetchBusinessAnnualReturnsDetails(this.effectiveTrackingNumber)
      }
    },
  },
  computed:{
    ...mapGetters(["getBusinessAnnualReturnsDetails","getBusinessAnnualReturnsDetailsError"]),
    detailsForm(){
      const details = this.getBusinessAnnualReturnsDetails
      if(details && (details.trackingNumber || details.trackingNo)){
        return details
      }
      if(details && details.data && (details.data.trackingNumber || details.data.trackingNo)){
        return details.data
      }
      return {}
    },
    effectiveTrackingNumber(){
      return this.trackingNumber
        || this.detailsForm.trackingNumber
        || this.detailsForm.trackingNo
        || null
    },
    hasDetails(){
      return Boolean(this.effectiveTrackingNumber)
    },
    detailsStatus(){
      const status = this.detailsForm.status
      return typeof status === "string" ? status.toLowerCase() : ""
    },
    yearsFiling(){
      const raw = this.detailsForm.years
      if(Array.isArray(raw)){
        return raw.map((y) => String(y).trim()).filter(Boolean)
      }
      if(typeof raw === "string"){
        return raw.split(",").map((y) => y.trim()).filter((y) => y.length > 0)
      }
      if(raw == null){
        return []
      }
      return [String(raw).trim()].filter(Boolean)
    },
    paymentPrn(){
      const d = this.detailsForm
      return d.prn || d.paymentPrn || (d.payment && d.payment.prn) || null
    },
    paymentStatus(){
      const d = this.detailsForm
      return d.paymentStatus || (d.payment && d.payment.status) || null
    },
    hasPaymentDetails(){
      return Boolean(this.paymentPrn || this.paymentStatus)
    }
  },
  watch:{
    trackingNumber(){
      this.currentRoute = "forms"
      this.loadDetails()
    },
    getBusinessAnnualReturnsDetails(){
      this.loading = false
    },
    getBusinessAnnualReturnsDetailsError(data){
      this.loading = false
      this.errorToast("Error", data?.message ?? data?.data?.message ?? "Failed to load application details")
    }
  }
};
</script>

<style scoped>

.icon{
  width: 170px;
}

th, td{
  font-size: 12px;
}

.years-wrap{
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.year-chip{
  @apply bg-header_grey text-blue font-bold;
}

.btn-escalate{
  @apply border border-blue rounded-sm text-blue text-sm px-3 py-1 mx-1 bg-white;
}

.btn-escalate:hover{
  @apply text-blue-dark;
}

.btn-approve{
  @apply border border-blue bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1;
}

.btn-query{
  @apply border border-blue bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1;
}

.btn-cancel{
  @apply border border-blue bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1;
}

.btn-approve:hover{
  @apply bg-green border-green text-white;
}

.btn-query:hover{
  @apply bg-orange border-orange text-white;
}

.btn-cancel:hover{
  @apply bg-red border-red text-white;
}

.btn-approve-hover{
  @apply bg-green border-green text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-query-hover{
  @apply bg-orange border-orange text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-approve-hover:hover{
  @apply bg-green-dark;
}

.btn-query-hover:hover{
  @apply bg-orange-dark;
}

</style>
